import React, { useRef } from 'react';
import { Link } from 'react-router-dom';
import RoutesApp from '../../routes';

//Estilos
import './ChangePassword.css';
import './ChangePasswordMediaQueries.css';

function ChangePassword({ functions, states }) {
    const {
        register,
        handleSubmit,
        watch,
        setError,
        formState: { errors },
        onSubmitUser,
        onSubmitPassword,
    } = functions;

    const { passwordSent } = states;

    const password = useRef({});
    password.current = watch('clave');

    const ConfirmPasswordChange = (
        <div
            className="form-background"
            onSubmit={handleSubmit(onSubmitPassword)}
        >
            <form className="form-confirm_password">
                {!passwordSent ? (
                    <h3>Ingrese su nueva clave</h3>
                ) : (
                    <h3>
                        Su clave ha sido cambiada exitosamente ingrese{' '}
                        <Link to={RoutesApp.Login}>aquí</Link> para iniciar
                        sesión
                    </h3>
                )}
                {!passwordSent && (
                    <>
                        <label className="label-confirm_password">
                            <span>Clave: </span>
                            <input
                                className="confirm_password-input"
                                type="password"
                                autoComplete="off"
                                {...register('clave', {
                                    required: 'La clave es requerida',
                                    minLength: {
                                        value: 8,
                                        message:
                                            'La clave debe tener un mínimo de 8 caracteres',
                                    },
                                    pattern: {
                                        value: /(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&-])[A-Za-z\d@$!%*?&#-]/,
                                        message:
                                            'La clave debe tener al menos una minúscula, una mayúscula, un número y un caracter especial [@$-!%*?&#]',
                                    },
                                })}
                                onKeyPress={(e) => {
                                    if (e.target.value.length > 20) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            {errors.clave && (
                                <small className="form__error">
                                    {errors.clave?.message}
                                </small>
                            )}
                        </label>

                        <label className="label-confirm_password">
                            <span>Confirmar clave: </span>
                            <input
                                className="confirm_password-input"
                                type="password"
                                autoComplete="off"
                                {...register('confirmPassword', {
                                    required:
                                        'Debe ingresar una clave de confirmación',
                                    validate: (value) =>
                                        value === password.current ||
                                        'Las claves no coinciden',
                                })}
                                onKeyPress={(e) => {
                                    if (e.target.value.length > 20) {
                                        e.preventDefault();
                                    }
                                }}
                            />
                            {errors.confirmPassword && (
                                <small className="form__error">
                                    {errors.confirmPassword?.message}
                                </small>
                            )}
                        </label>
                        <button className="btn btn-primary" type="submit">
                            Confirmar
                        </button>
                    </>
                )}
            </form>
        </div>
    );

    return ConfirmPasswordChange;
}

export default ChangePassword;
